import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { INFO_SA_EMAIL, SA_WEBSITE } from 'consts'
import { useIsMobile } from 'utils/responsive-design'
import { SaLogoMinimal } from 'components/SaLogo'

/**
 * Footer component displays the footer of the application.
 * It includes the current year, contact email, and a link to the swissanalytica website.
 * @returns JSX.Element
 */
export const Footer: React.FC = () => {
  const isMobile = useIsMobile()
  const theme = useTheme()

  return (
    <Box
      component='footer'
      sx={{
        // boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        borderTop: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.default,
        display: 'flex',
        justifyContent: !isMobile ? 'space-between' : 'center',
        flexDirection: isMobile ? 'column-reverse' : 'row',
        alignItems: 'center',
        py: 1.8,
        px: 4,
        backgroundColor: '',
        color: theme.palette.text.primary,
        mt: 'auto',
        gap: isMobile ? 1 : 0,
        ml: '65px',
        [theme.breakpoints.down('sm')]: {
          ml: '56px'
        }
      }}
    >
      <Typography variant='body2' textAlign={isMobile ? 'center' : undefined}>
        © {new Date().getFullYear()} swissanalytica |{' '}
        <a
          href={`mailto:${INFO_SA_EMAIL}`}
          style={{ color: 'inherit', textDecoration: 'none' }}
        >
          {INFO_SA_EMAIL}
        </a>
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant='body2'>Powered by</Typography>
        <a href={SA_WEBSITE} target='_blank'>
          <SaLogoMinimal />
        </a>
      </Box>
    </Box>
  )
}

export default Footer
